import { render, staticRenderFns } from "./NovoSimuladoView.vue?vue&type=template&id=9c2cf4d6&scoped=true"
import script from "./NovoSimuladoView.vue?vue&type=script&lang=js"
export * from "./NovoSimuladoView.vue?vue&type=script&lang=js"
import style0 from "./NovoSimuladoView.vue?vue&type=style&index=0&id=9c2cf4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2cf4d6",
  null
  
)

export default component.exports